<template>
  <el-tooltip :content="content" :placement="placement" popper-class="hint-icon-popper">
    <el-icon :class="['hint-icon', { 'hint-icon--review': REVIEW }]">
      <QuestionFilled />
    </el-icon>
  </el-tooltip>
</template>

<script setup lang="ts">
/**
 * 全局提示图标：QuestionFilled + hover 提示气泡。
 * 系统内专业名词 / 易误解功能统一用此组件补充说明，保证图标与交互一致。
 *
 * REVIEW 为「审核期」开关：
 *  - true：图标为醒目的红色 24px，便于在页面中快速发现所有新加的提示词、核对文案与位置；
 *  - 审核确认后改为 false，即全站统一切回项目既有灰色标准样式（QuestionFilled + text-slate-400）。
 */
import { QuestionFilled } from '@element-plus/icons-vue';

withDefaults(
  defineProps<{
    /** 提示文案 */
    content: string;
    /** 气泡位置，默认 top */
    placement?:
      | 'top'
      | 'top-start'
      | 'top-end'
      | 'bottom'
      | 'bottom-start'
      | 'bottom-end'
      | 'left'
      | 'right';
  }>(),
  { placement: 'top' },
);

/** 审核期：红色 24px 醒目图标；上线前改为 false 即切回灰色标准样式 */
const REVIEW = false;
</script>

<style scoped lang="scss">
.hint-icon {
  color: #94a3b8; // 灰色标准（text-slate-400）
  font-size: 14px;
  cursor: help;
  vertical-align: -2px;
  margin-left: 4px;
}

/** 审核期醒目样式：红色 24px（上线前随 REVIEW 关闭自动移除） */
.hint-icon--review {
  color: #f56c6c;
  font-size: 24px;
  vertical-align: middle;
}
</style>

<style lang="scss">
/** 提示气泡限宽，长文案自动换行；content 中的 \n 换行符按其渲染（作用于 teleport 出去的 popper，故不加 scoped） */
.hint-icon-popper.el-popper {
  max-width: 320px;
  line-height: 1.6;
  white-space: pre-line;
}
</style>
